import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledAlertContainer = styled.div`
  position: fixed;
  right: 30px;
  top: 40px;
  z-index: 101;

  animation: alertAnimation ease-in-out 0.3s;
  animation-iteration-count: 1;
  transform-origin: 50% 50%;

  @keyframes alertAnimation {
    0% {
      opacity: 0;
      transform: translate(20px, 0px);
    }
    100% {
      opacity: 1;
      transform: translate(0px, 0px);
    }
  }

  @media (max-width: 991px) {
    left: 0;
    right: 0;
    margin-top: -15px;
  }
`;

export const StyledMessageCode = styled.div`
  display: flex;
  align-items: center;
  font-size: ${themeGet('fontSizes.base')}px;
  color: ${themeGet('colors.primary.extra')};
  line-height: 1.5;

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const StyledAlert = styled.div<{
  success?: boolean;
  closing?: string;
}>`
  background-color: #fff;
  border-width: 2px;
  border-style: solid;
  border-color: ${(props) => (props.success ? '#02ba86' : '#e2a1a1')};
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
  border-radius: ${themeGet('radii.base')};
  margin-bottom: 12px;

  @media (max-width: 991px) {
    width: 100%;
  }

  &.number-${(props) => props?.closing} {
    animation: alertAnimationClose ease-in-out 0.3s forwards;
  }

  animation-iteration-count: 1;
  transform-origin: 50% 50%;

  @keyframes alertAnimationClose {
    0% {
      opacity: 1;
      transform: translate(0px, 0px);
    }
    100% {
      opacity: 0;
      transform: translate(16px, 0px);
    }
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  min-height: 100px;
  max-width: 345px;
  min-width: 345px;
  box-shadow: ${themeGet('shadows.card')};

  @media (max-width: 991px) {
    width: 100%;
    max-width: 100%;
  }
`;

export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  img {
    margin-right: 18px;
    width: 24px;
  }
`;

export const StyledText = styled.div`
  flex: 1 1 auto;
`;

export const StyledClose = styled.div`
  position: absolute;
  right: 21px;
  top: 21px;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  flex: 0 0 18px;
  transform-origin: 50% 38%;

  &:hover {
    transform: rotate(135deg);
  }
`;

export const StyledHeader = styled.div<{
  success?: string;
}>`
  font-weight: ${themeGet('fontWeights.semi')};
  font-size: 20px;
  text-transform: capitalize;

  color: ${(props) => (props.success ? '#02ba86' : '#ba1717')};
`;

export const StyledConsole = styled.div`
  font-family: inherit;
  font-size: ${themeGet('fontSizes.xs')}px;
  color: ${themeGet('colors.primary.extra')};
  border-radius: ${themeGet('radii.little')};
  line-height: 24px;
  margin-top: 8px;
  background-color: #e6e6e6;
  padding: 4px 10px;
  word-break: break-word;
`;
